export default __webpack_public_path__ + "asset/img/more-shipping-list-3~4600b7e2.png";